import type { ReactElement } from 'react';
export type SpecialistVisualIconName =
  | 'weather'
  | 'agenda'
  | 'waiting'
  | 'bills'
  | 'dates'
  | 'news'
  | 'horoscope'
  | 'shopping'
  | 'produce'
  | 'bread'
  | 'fridge'
  | 'pantry'
  | 'drinks'
  | 'cleaning'
  | 'care'
  | 'other'
  | 'market'
  | 'groups'
  | 'retrospective'
  | 'travel';

const ART: Record<SpecialistVisualIconName, ReactElement> = {
  weather: (
    <>
      <circle cx="15" cy="12" r="5" fill="#F5B84E" />
      <g stroke="#F5B84E" strokeWidth="2" strokeLinecap="round">
        <path d="M15 3v2M15 19v2M6 12H4M26 12h-2M8.6 5.6 7.2 4.2M22.8 19.8l-1.4-1.4M21.4 5.6l1.4-1.4" />
      </g>
      <path
        d="M9 25h13.5a4.5 4.5 0 0 0 .2-9 7 7 0 0 0-12.9 2.1A3.5 3.5 0 0 0 9 25Z"
        fill="#D8F0F8"
        stroke="#65AFCB"
        strokeWidth="1.7"
      />
    </>
  ),
  agenda: (
    <>
      <rect
        x="5"
        y="6"
        width="22"
        height="21"
        rx="5"
        fill="#FFF0E2"
        stroke="#C97750"
        strokeWidth="1.7"
      />
      <path d="M5 12h22" stroke="#C97750" strokeWidth="1.7" />
      <path d="M11 4v5M21 4v5" stroke="#814D39" strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="11" cy="17" r="2" fill="#E89B68" />
      <circle cx="17" cy="17" r="2" fill="#F3C282" />
      <circle cx="22" cy="22" r="2" fill="#B8765A" />
    </>
  ),
  waiting: (
    <>
      <circle cx="16" cy="16" r="11" fill="#EEE4F7" stroke="#8B67AA" strokeWidth="1.7" />
      <path
        d="M16 9v7l4 3"
        fill="none"
        stroke="#6F4C90"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="16" cy="16" r="2" fill="#9E78BE" />
    </>
  ),
  bills: (
    <>
      <path
        d="M8 4h13l4 4v20l-3-2-3 2-3-2-3 2-3-2-3 2V5a1 1 0 0 1 1-1Z"
        fill="#E1F4E8"
        stroke="#4D956D"
        strokeWidth="1.6"
      />
      <path
        d="M11 11h10M11 15h10M11 20h6"
        stroke="#4D956D"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="22" cy="22" r="5" fill="#5BA677" />
      <path
        d="m20 22 1.3 1.3L24 20.5"
        fill="none"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  dates: (
    <>
      <path
        d="M16 27s-9-5.6-9-13a5.7 5.7 0 0 1 10.2-3.5A5.7 5.7 0 0 1 27 14c0 7.4-11 13-11 13Z"
        fill="#F6DCE5"
        stroke="#C75072"
        strokeWidth="1.6"
      />
      <path d="M16 8v17" stroke="#C75072" strokeWidth="1.5" strokeDasharray="2.5 3" />
      <circle cx="16" cy="8" r="2.3" fill="#E5985A" />
    </>
  ),
  news: (
    <>
      <rect
        x="4"
        y="7"
        width="21"
        height="19"
        rx="3.5"
        fill="#FFF0DF"
        stroke="#C9753C"
        strokeWidth="1.7"
      />
      <rect x="8" y="11" width="7" height="6" rx="1.5" fill="#E9A76B" />
      <path d="M18 11h4M18 14h4M8 21h14" stroke="#A95D32" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M25 12h3v10a4 4 0 0 1-4 4" fill="none" stroke="#C9753C" strokeWidth="1.7" />
    </>
  ),
  horoscope: (
    <>
      <path
        d="M20 5a10 10 0 1 0 7 15 9 9 0 0 1-7-15Z"
        fill="#EAE3FA"
        stroke="#735AA8"
        strokeWidth="1.6"
      />
      <path
        d="m9 8 .7 2.1L12 11l-2.3.8L9 14l-.8-2.2L6 11l2.2-.9L9 8Zm16 0 .5 1.5L27 10l-1.5.5L25 12l-.5-1.5L23 10l1.5-.5L25 8Z"
        fill="#D8A84E"
      />
    </>
  ),
  shopping: (
    <>
      <path
        d="M6 9h3l2.4 13h11.9l2-9.2H10"
        fill="#EEF5D9"
        stroke="#6F9439"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13 13v7M18 13v7M23 14l-1 6" stroke="#95B85E" strokeWidth="1.4" />
      <circle cx="14" cy="26" r="2.2" fill="#668936" />
      <circle cx="22" cy="26" r="2.2" fill="#668936" />
    </>
  ),
  produce: (
    <>
      <path
        d="M16 12c-5-5-10-.8-9 5.3C8 23 12 27 16 28c4-1 8-5 9-10.7 1-6.1-4-10.3-9-5.3Z"
        fill="#E9F2D3"
        stroke="#6F963D"
        strokeWidth="1.6"
      />
      <path d="M16 12c-1-5 2-8 6-8-1 4-3 6-6 8Z" fill="#78A74A" />
      <path d="M16 12c-2-3-5-4-7-3" stroke="#55832F" strokeWidth="1.7" strokeLinecap="round" />
    </>
  ),
  bread: (
    <>
      <path
        d="M6 20c0-8 5-13 11-13 5 0 9 4 9 9 0 6-5 10-12 10-5 0-8-2-8-6Z"
        fill="#F8DFB0"
        stroke="#C98440"
        strokeWidth="1.6"
      />
      <path
        d="m13 10 2 4M18 9l2 4M22 11l1 4"
        stroke="#D99C58"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </>
  ),
  fridge: (
    <>
      <rect
        x="8"
        y="3"
        width="17"
        height="26"
        rx="4"
        fill="#E6F3F5"
        stroke="#5C9EA7"
        strokeWidth="1.6"
      />
      <path d="M8 14h17M12 8v3M12 18v5" stroke="#5C9EA7" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M20 7h2v4h-2z" fill="#A6D4D9" />
    </>
  ),
  pantry: (
    <>
      <path d="M7 9h18v18H7z" fill="#F2E6D5" stroke="#9B704A" strokeWidth="1.6" />
      <path d="M5 7h22v4H5z" fill="#D3AA77" stroke="#8B653F" strokeWidth="1.5" />
      <path d="M12 16h8M12 20h8" stroke="#A87C50" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  drinks: (
    <>
      <path d="M10 5h12l-1 22H11L10 5Z" fill="#DDF0F7" stroke="#5096B0" strokeWidth="1.6" />
      <path d="M12 14c3 2 6-2 9 0" fill="none" stroke="#63B6D1" strokeWidth="1.7" />
      <path d="m17 5 3-3h4" stroke="#B55E64" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  cleaning: (
    <>
      <path d="M13 4h7v6l4 4v13H8V14l5-4V4Z" fill="#E6E2F6" stroke="#7764A0" strokeWidth="1.6" />
      <path d="M13 7h7M11 17h10" stroke="#7764A0" strokeWidth="1.6" />
      <circle cx="24" cy="8" r="2" fill="#9FD8E7" />
      <circle cx="27" cy="4" r="1.3" fill="#B8E7F0" />
    </>
  ),
  care: (
    <>
      <path
        d="M16 27s-9-5.4-9-13a5.5 5.5 0 0 1 9-4.2A5.5 5.5 0 0 1 25 14c0 7.6-9 13-9 13Z"
        fill="#F7DEE8"
        stroke="#BE5F7F"
        strokeWidth="1.6"
      />
      <path d="M16 12v8M12 16h8" stroke="#BE5F7F" strokeWidth="2" strokeLinecap="round" />
    </>
  ),
  other: (
    <>
      <circle cx="9" cy="16" r="3" fill="#E8DFF4" />
      <circle cx="16" cy="16" r="3" fill="#C9B3E0" />
      <circle cx="23" cy="16" r="3" fill="#A98BC8" />
    </>
  ),
  market: (
    <>
      <path
        d="M5 25 12 17l5 3 9-13"
        fill="none"
        stroke="#4E8D66"
        strokeWidth="2.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m21 7 5-.5-.3 5"
        fill="none"
        stroke="#4E8D66"
        strokeWidth="2.3"
        strokeLinecap="round"
      />
      <path d="M5 27h22" stroke="#92B69E" strokeWidth="1.6" />
    </>
  ),
  groups: (
    <>
      <path d="M5 7h22v16H15l-6 5v-5H5V7Z" fill="#E4F1ED" stroke="#4C8B78" strokeWidth="1.6" />
      <circle cx="11" cy="15" r="2" fill="#6BA58F" />
      <circle cx="16" cy="15" r="2" fill="#6BA58F" />
      <circle cx="21" cy="15" r="2" fill="#6BA58F" />
    </>
  ),
  retrospective: (
    <>
      <rect
        x="6"
        y="6"
        width="20"
        height="20"
        rx="5"
        fill="#F3E7F7"
        stroke="#8F65A2"
        strokeWidth="1.6"
      />
      <path
        d="M11 21v-4M16 21v-8M21 21V9"
        stroke="#8F65A2"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </>
  ),
  travel: (
    <>
      <path
        d="m5 18 9-3 7-9c1-1.2 3-2 4-1 1 1 0 3-1 4l-7 8-2 10-2 1-1-9-5 3-1 4-2 1v-6l-4-3 1-2 4 2Z"
        fill="#DFF0F6"
        stroke="#4D8DA7"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </>
  ),
};

export const specialistVisualForKey = (key: string): SpecialistVisualIconName =>
  (({
    bom_dia: 'weather',
    horoscopo: 'horoscope',
    noticias: 'news',
    contas: 'bills',
    mercado: 'market',
    clima: 'weather',
    datas_importantes: 'dates',
    resumo_grupos: 'groups',
    radar_precos: 'market',
    lista_compras: 'shopping',
    retrospectiva: 'retrospective',
    passagens: 'travel',
  })[key] as SpecialistVisualIconName | undefined) ?? 'other';

export function SpecialistVisualIcon({
  name,
  size = 32,
  className = '',
}: {
  name: SpecialistVisualIconName;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role="img"
      aria-hidden="true"
    >
      {ART[name]}
    </svg>
  );
}
